import {lazy} from "react";

export const MutateGroupsWithListLazy = lazy(()=>import('./MutateGroupsWithList'))